module.exports = __webpack_public_path__ + "img/20200506145234TIM截图20200506144340.079ea15e.png";